import React from 'react';

import { Switch } from 'react-router-dom';

import SignIn from '../pages/SignIn';
import Dashboard from '../pages/Dashboard';
import Cursos from '../pages/Cursos';
import CriarCursos from '../pages/CriarCursos';
import Associado from '../pages/Associado';
import AlterarAssociado from '../pages/AlterarAssociado';
import AlterarArtigo from '../pages/AlterarArtigo';
import AlterarCurso from '../pages/AlterarCurso';
import Artigos from '../pages/Artigos';
import CriarArtigo from '../pages/CriarArtigo';

import Route from './Route';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />

    <Route path="/dashboard" isPrivate component={Dashboard} />
    <Route path="/cursos" exact isPrivate component={Cursos} />
    <Route path="/cursos/criar" isPrivate component={CriarCursos} />
    <Route path="/cursos/alterar/:id" isPrivate component={AlterarCurso} />

    <Route path="/artigos" exact isPrivate component={Artigos} />
    <Route path="/artigos/criar" isPrivate component={CriarArtigo} />
    <Route path="/artigos/alterar/:id" isPrivate component={AlterarArtigo} />

    <Route path="/associados" isPrivate exact component={Associado} />
    <Route path="/associados/alterar/:id" isPrivate component={AlterarAssociado} />

  </Switch>
);

export default Routes;
